import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { Aggregators } from '../utils/aggregator';

const dateRanges = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'week', label: 'Last 7 days' },
    { value: 'month', label: 'Last 30 days' },
    { value: 'year', label: 'Last 365 days' },
    { value: 'custom', label: 'Custom Period' },
];

const platforms = [
    { value: 'iOS', label: 'iOS' },
    { value: 'Android', label: 'Android' },
    { value: 'all', label: 'All platforms' },
];

const aggregators = Object.keys(Aggregators).map(k => ({ value: k, label: Aggregators[k] }));

function Filters({ initialValues, onApply, loading }) {
    const [dateRange, setDateRange] = useState(initialValues?.dateRange || 'month');
    const [startDate, setStartDate] = useState(initialValues?.startDate ? initialValues.startDate.slice(0, 10) : '');
    const [endDate, setEndDate] = useState(initialValues?.endDate ? initialValues.endDate.slice(0, 10) : '');
    const [aggregator, setAggregator] = useState(initialValues?.aggregator || 'Single & Multi-station apps');
    const [platform, setPlatform] = useState(initialValues?.platform || 'all');

    const handleApply = (e) => {
        e.preventDefault();
        onApply({
            dateRange,
            startDate: dateRange === 'custom' ? startDate : undefined,
            endDate: dateRange === 'custom' ? endDate : undefined,
            aggregator,
            platform,
        });
    };

    return (
        <Box component="form" onSubmit={handleApply} sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, flexWrap: 'wrap' }}>
            <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Date Range</InputLabel>
                <Select
                    value={dateRange}
                    label="Date Range"
                    onChange={e => setDateRange(e.target.value)}
                >
                    {dateRanges.map(opt => (
                        <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            {dateRange === 'custom' && (
                <>
                    <TextField
                        label="Start Date"
                        type="date"
                        size="small"
                        value={startDate}
                        onChange={e => setStartDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <span>to</span>
                    <TextField
                        label="End Date"
                        type="date"
                        size="small"
                        value={endDate}
                        onChange={e => setEndDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                </>
            )}
            <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel>Aggregator</InputLabel>
                <Select
                    value={aggregator}
                    label="Aggregator"
                    onChange={e => setAggregator(e.target.value)}
                >
                    {aggregators.map(opt => (
                        <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Platform</InputLabel>
                <Select
                    value={platform}
                    label="Platform"
                    onChange={e => setPlatform(e.target.value)}
                >
                    {platforms.map(opt => (
                        <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <Button className='uppercase' type="submit" variant="contained" color="primary" disabled={loading}  sx={{ minWidth: 120, textTransform: 'capitalize' }}>
                {loading ? 'Applying...' : 'Apply'}
            </Button>
        </Box>
    );
}

Filters.propTypes = {
    initialValues: PropTypes.object,
    onApply: PropTypes.func.isRequired,
    loading: PropTypes.bool,
};

export default Filters; 